import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { Observable } from 'rxjs';
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';
import { VenencGuiaRemision } from "../veninterfaces/venencGuiaRemision";

@Injectable({
  providedIn: 'root'
})
export class VenguiasService {
  get encguia(): VenencGuiaRemision[] {
    return this._encguia;
  }

  set encguia(value: VenencGuiaRemision[]) {
    this._encguia = value;
  }

  public url: any;
  private _encguia: VenencGuiaRemision[];
  public way: string;


  constructor(
    private http: HttpClient, private confIniciales: ConfInicialesService,
    public usuarioEsquema: UsuarioEsquema, public usuario: Usuario
  ) { 
    this.url = sessionStorage.getItem('url');
    this.way = sessionStorage.getItem('way');
  }
  getEncGreFac(cliCodigo,strfecha,strDSNEBINGR): Observable<any[]> {
    return this.http.post<any[]>(this.way + '/ventas/venguias/10775d76436e', {
      elementos: {
        CLI_CODIGO: cliCodigo,
        FECHA:strfecha,
        DSNEBINGR:strDSNEBINGR
      },
    }, this.confIniciales.httpOptions());
  }
  getDetGuias(guiacodigo: string): Observable<any[]> {
    return this.http.post<any[]>(this.way + '/ventas/venguias/10775aeec36e', {
      elementos: {
        ENCGRE_NUMERO: guiacodigo
      },
    }, this.confIniciales.httpOptions());
  }

}
